import { Colors, Text } from '@mercator-gcp/grout';
import { FlexRow } from 'components/layout/FlexRow';

const noProjectsMessageStyles = {
  width: '100%',
  justifyContent: 'center',
};

const NoProjectsMatchFiltersMessage = () => (
  <FlexRow sx={noProjectsMessageStyles}>
    <Text.Lead color={Colors.TextQuiet}>No projects match your fiters</Text.Lead>
  </FlexRow>
);

export default NoProjectsMatchFiltersMessage;
